export const GENERIC_ERROR_MESSAGE = "Something went wrong, try again or contact customer support.";
